import { isAxiosError } from "axios"
import type { AxiosError } from "axios"

export const BAD_CREDENTIALS_SERVER_MESSAGE = "Bad credentials" as const

export type PasswordFormError = Error | AxiosError<unknown, unknown> | null

type GetPasswordFormDisplayedErrorParams = {
  readonly error: PasswordFormError
  readonly invalidCredentialsMessage: string
}

const getAxiosResponseMessage = (
  error: AxiosError<unknown, unknown>
): string | undefined => {
  const { data } = error.response ?? {}

  if (typeof data === "string") {
    return data.length > 0 ? data : undefined
  }

  if (
    typeof data === "object" &&
    data !== null &&
    "message" in data &&
    typeof data.message === "string"
  ) {
    return data.message
  }

  return undefined
}

export const getPasswordFormDisplayedError = ({
  error,
  invalidCredentialsMessage,
}: GetPasswordFormDisplayedErrorParams): PasswordFormError => {
  if (!isAxiosError(error) || error.response?.status !== 401) {
    return error
  }

  const serverMessage = getAxiosResponseMessage(error)

  if (serverMessage === BAD_CREDENTIALS_SERVER_MESSAGE) {
    return new Error(invalidCredentialsMessage)
  }

  if (serverMessage) {
    return new Error(serverMessage)
  }

  return error
}
